import React, {useState, useEffect, useCallback, useMemo} from 'react'
import axios from "axios";

import Search from "../../icons/search";

import "./admin_api_balances.css"

const ADMIN_API_BASE_URL = "https://u439lq97h7.execute-api.us-west-2.amazonaws.com/dev";

const adminApiUrl = (path) => `${ADMIN_API_BASE_URL}${path}`;

const getErrorMessage = (error) => {
  return error?.response?.data?.errorMessage || "El admin no respondio. Intenta nuevamente.";
}

function AdminApiBalances(props) {

    const [apiBalances, setApiBalances] = useState({ calls: [], apis: [] });
    const [apiBalancesLoad, setApiBalancesLoad] = useState(true);
    const [apiBalancesError, setApiBalancesError] = useState("");

    const [balanceInput, setBalanceInput] = useState({});

    const [searchEmail, setSearchEmail] = useState("");
    const [searchApi, setSearchApi] = useState({});
    const [expandedClient, setExpandedClient] = useState("");
    const [savingBalance, setSavingBalance] = useState("");

    const handleBalanceChange = (value, id) => {
      const balanceInputNew = { ...balanceInput }
      balanceInputNew[id] = value.replace(/\D/g, '');
      setBalanceInput(balanceInputNew)
    }

    const getClientKey = (apiBalance) =>
      apiBalance.ClientId || apiBalance.CredentialId || apiBalance.Email;

    const getFullName = (apiBalance) =>
      [apiBalance.Name, apiBalance.SecondLastname, apiBalance.FirstLastname]
        .filter(Boolean)
        .join(" ") || "-";

    const getTotalBalance = (apiBalance) => {
      const currentApis = Array.isArray(apiBalance.Apis) ? apiBalance.Apis : [];
      return currentApis.reduce((total, api) => {
        const numberCall = Number(api.NumberCall);
        return Number.isFinite(numberCall) ? total + numberCall : total;
      }, 0);
    }

    const calls = useMemo(() => (
      Array.isArray(apiBalances.calls) ? apiBalances.calls : []
    ), [apiBalances]);

    const allApis = useMemo(() => {
      const apisById = {};
      const responseApis = Array.isArray(apiBalances.apis) ? apiBalances.apis : [];

      responseApis.forEach((api) => {
        const apiId = api.ApiId || api.ApiName;
        if (!apiId || apisById[apiId]) return;

        apisById[apiId] = {
          ApiId: api.ApiId,
          ApiName: api.ApiName || "API sin nombre",
        };
      });

      calls.forEach((apiBalance) => {
        const apis = Array.isArray(apiBalance.Apis) ? apiBalance.Apis : [];
        apis.forEach((api) => {
          const apiId = api.ApiId || api.ApiName;
          if (!apiId || apisById[apiId]) return;

          apisById[apiId] = {
            ApiId: api.ApiId,
            ApiName: api.ApiName || "API sin nombre",
            fromExistingBalance: true,
          };
        });
      });

      return Object.values(apisById).sort((a, b) =>
        a.ApiName.localeCompare(b.ApiName)
      );
    }, [apiBalances, calls]);

    const filteredBalances = useMemo(() => {
      const emailQuery = searchEmail.trim().toLowerCase();

      return calls
        .filter((apiBalance) =>
          (apiBalance.Email || "").toLowerCase().includes(emailQuery)
        )
        .sort((a, b) => getTotalBalance(b) - getTotalBalance(a));
    }, [calls, searchEmail]);

    const getMergedApis = (apiBalance) => {
      const currentApis = Array.isArray(apiBalance.Apis) ? apiBalance.Apis : [];
      const currentById = {};
      const currentByName = {};

      currentApis.forEach((api) => {
        const apiId = api.ApiId || api.ApiName;
        if (apiId) currentById[apiId] = api;
        if (api.ApiName) currentByName[api.ApiName] = api;
      });

      const merged = allApis.map((api) => {
        const apiId = api.ApiId || api.ApiName;
        return currentById[apiId] || currentByName[api.ApiName] || {
          ...api,
          NumberCall: "",
          missingBalance: true,
        };
      });

      return merged.length ? merged : currentApis;
    }

    const handleApiSearchChange = (clientKey, value) => {
      setSearchApi({
        ...searchApi,
        [clientKey]: value
      });
    }

    const loadBalances = useCallback(() => {
        setApiBalancesLoad(true);
        setApiBalancesError("");

        axios.post(adminApiUrl("/admin/api-balances"))
        .then((res) => {
            setApiBalances({
              calls: Array.isArray(res.data.calls) ? res.data.calls : [],
              apis: Array.isArray(res.data.apis) ? res.data.apis : []
            })
            if (!Array.isArray(res.data.calls)) {
              setApiBalancesError(res.data.errorMessage || "La respuesta de balances no fue valida.");
            }
        })
        .catch((err) => {
            setApiBalances({ calls: [], apis: [] })
            setApiBalancesError(getErrorMessage(err))
        })
        .finally(() => {
            setApiBalancesLoad(false);
        })
    }, [])

    const buildUpdate = (key, value) => {
      if (key.startsWith("new::")) {
        const [, ClientId, ApiId] = key.split("::");
        return {
          ClientId,
          ApiId,
          NumberCall: value,
          PlanType: "manual"
        };
      }

      return {
        CallApiClientId: key,
        NumberCall: value,
        PlanType: "manual"
      };
    }

    const saveBalance = (key) => {
      const value = balanceInput[key];
      if (value === undefined || value === "") return;

      setSavingBalance(key)
      setApiBalancesError("");

      axios.post(adminApiUrl("/admin/api-balances/update"), {
        updates: [buildUpdate(key, value)],
        updateObj: key.startsWith("new::") ? undefined : { [key]: value }
      })
      .then(() => {
        setBalanceInput((current) => {
          const next = { ...current };
          delete next[key];
          return next;
        })
        loadBalances()
      })
      .catch((err) => {
        setApiBalancesError(getErrorMessage(err))
      })
      .finally(() => setSavingBalance(""))
    }

    useEffect(() => {
        loadBalances();
    }, [loadBalances]);


  return (
<>
      {
        apiBalancesError &&
        <div className="admin_api_error">
          <span>{apiBalancesError}</span>
          <button type="button" onClick={() => loadBalances()}>Reintentar</button>
        </div>
      }
      {
        !apiBalancesLoad ?
        <div className="card_list api_card_list api_prices_container api_balances_container api_balances_manager">
        <div className="api_balances_topbar">
          <div className="api_balances_summary">
            <span>{filteredBalances.length} usuarios</span>
            <span>{allApis.length} APIs disponibles</span>
          </div>
          <div className="api_balances_email_search">
            <Search />
            <input className="api_balances_search" type="text" placeholder="Buscar por correo" value={searchEmail} onChange={(e) => setSearchEmail(e.target.value)}/>
          </div>
        </div>
        <div className="api_balances_user_list">
          <div className="api_balance_user_list_header">
            <span>Correo</span>
            <span>Nombre</span>
            <span>Saldo total</span>
            <span>APIs</span>
            <span>Accion</span>
          </div>
        {
            filteredBalances
            .map(apiBalance => {
              const clientKey = getClientKey(apiBalance);
              const isExpanded = expandedClient === clientKey;
              const apiQuery = (searchApi[clientKey] || "").trim().toLowerCase();
              const mergedApis = getMergedApis(apiBalance).filter((api) =>
                (api.ApiName || "").toLowerCase().includes(apiQuery)
              );
              const currentApis = Array.isArray(apiBalance.Apis) ? apiBalance.Apis : [];
              const totalBalance = getTotalBalance(apiBalance);

              return (
                <div className={"api_balance_user" + (isExpanded ? " api_balance_user_open" : "")} key={clientKey}>
                  <button
                    className="api_balance_user_header"
                    type="button"
                    onClick={() => setExpandedClient(isExpanded ? "" : clientKey)}
                  >
                    <span className="api_balance_user_identity">
                      <strong>{apiBalance.Email}</strong>
                    </span>
                    <span className="api_balance_user_name">{getFullName(apiBalance)}</span>
                    <span className="api_balance_user_meta">
                      <span>{totalBalance.toLocaleString()} llamadas</span>
                      <span>{currentApis.length} APIs</span>
                      <span>{isExpanded ? "Cerrar" : "Gestionar saldo"}</span>
                    </span>
                  </button>

                  {
                    isExpanded &&
                    <div className="api_balance_user_panel">
                      <div className="api_balance_panel_toolbar">
                        <div className="api_balance_panel_note">
                          <strong>{apiBalance.Email}</strong>
                          <span>Asigna o actualiza llamadas por API.</span>
                        </div>
                        <input
                          type="text"
                          value={searchApi[clientKey] || ""}
                          onChange={(e) => handleApiSearchChange(clientKey, e.target.value)}
                          placeholder="Buscar API"
                        />
                      </div>

                      <div className="api_balance_api_list" role="table">
                        <div className="api_balance_api_header" role="row">
                          <span>API</span>
                          <span>Actual</span>
                          <span>Nuevo saldo</span>
                          <span>Accion</span>
                        </div>
                        {
                          mergedApis.map(apiBalanceApi => {
                            const inputId = apiBalanceApi.CallApiClientId || `new::${apiBalance.ClientId}::${apiBalanceApi.ApiId}`;
                            const canEdit = Boolean(apiBalanceApi.CallApiClientId || (apiBalance.ClientId && apiBalanceApi.ApiId));
                            const hasChange = balanceInput[inputId] !== undefined && balanceInput[inputId] !== "" && String(balanceInput[inputId]) !== String(apiBalanceApi.NumberCall || "");
                            const isSaving = savingBalance === inputId;

                            return (
                              <div className={"api_balance_api_row" + (canEdit ? "" : " api_balance_api_row_missing")} key={apiBalanceApi.CallApiClientId || apiBalanceApi.ApiId || apiBalanceApi.ApiName}>
                                <div className="api_balance_api_name">
                                  <span>{apiBalanceApi.ApiName}</span>
                                  {!apiBalanceApi.CallApiClientId && <small>Sin asignar</small>}
                                </div>
                                <span className="api_balance_current_value">{apiBalanceApi.NumberCall === "" ? "-" : apiBalanceApi.NumberCall}</span>
                                <div className="table_balances_item_input">
                                  <input
                                    type="text"
                                    disabled={!canEdit}
                                    onChange={(e) => handleBalanceChange(e.target.value, inputId)}
                                    value={canEdit ? (balanceInput[inputId] !== undefined ? balanceInput[inputId] : apiBalanceApi.NumberCall) : ""}
                                    placeholder="0"
                                  />
                                  <div className="input_bar_focus"></div>
                                </div>
                                <button
                                  className={"api_balance_save_btn" + (hasChange ? " api_balance_save_btn_active" : "")}
                                  type="button"
                                  disabled={!canEdit || !hasChange || isSaving}
                                  onClick={() => saveBalance(inputId)}
                                >
                                  {isSaving ? "Guardando" : apiBalanceApi.CallApiClientId ? "Actualizar" : "Asignar"}
                                </button>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  }
                </div>
              )
            })
        }
        </div>
      </div>
        :
        <>
          <div className="task_card_skeleton"></div>
          <div className="task_card_skeleton"></div>
          <div className="task_card_skeleton"></div>
        </>
      }

    </>
  )
}

export default AdminApiBalances
